<template>
  <div id="location">
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>商城用户&nbsp;/&nbsp;地址管理</span>
        </div>
        <div style="display: flex;flex-wrap: wrap;align-items: center;">
         <el-input class="elinputs" v-model="beginData.nickname" placeholder="收货人"></el-input>
         <el-input class="elinputs" v-model="beginData.mobile" placeholder="手机号"></el-input>
         <el-input class="elinputs" v-model="beginData.id" placeholder=" 用户编号"></el-input>
          <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
          <el-button type="info" @click='resets'>重置</el-button>
        </div>
        <div class="tit">
          <el-button type="info" size="small" class="all_btn" icon="el-icon-warning-outline" @click="reset">刷新</el-button>
          <Xlsx :name="formname"></Xlsx>
        </div>
        <el-table :data="tableData" id="exportTab" border stripe style="width: 100%">
        <!-- <el-table-column type="selection" width="60"> </el-table-column> -->
        <!-- <el-table-column type="index" label="序号" width="55" :index="1"></el-table-column> -->
        <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
        <el-table-column prop="id" label="用户编号" width="120"></el-table-column>
        <el-table-column prop="nickname" label="昵称" width="160"></el-table-column>
        <el-table-column min-width="120" label="头像">
            <template slot-scope="scope">
              <viewer>
                  <img class="sfzimg" :src="scope.row.avatar" />
              </viewer>
            </template>
        </el-table-column>
        <el-table-column prop="name" label="收货人" width="160"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="160"></el-table-column>
        <el-table-column prop="provinceName" label="省份" width="120"></el-table-column>
        <el-table-column prop="cityName" label="城市" width="120"></el-table-column>
        <el-table-column prop="districtName" label="区县" width="120"></el-table-column>
        <el-table-column prop="address" label="详细地址" width="200"></el-table-column>
        <el-table-column label="是否默认" width="150">
            <template slot-scope="scope">
                <p class="boldfont" v-if="scope.row.isDefault">是</p>
                <p class="boldfont" v-else style="color:#F56C6C">否</p>
            </template>
        </el-table-column>
        <el-table-column prop="addTime" label="创建时间" fixed="right" min-width="180"></el-table-column>
        </el-table>
        <div class="paging">
            <span>
            共
            <i class="pagingNum">{{total}}</i> 条
            </span>
            <Paging :gopage="total" @pag="pag"></Paging>
        </div>
    </el-card>
  </div>
</template>
<script>
import Xlsx from "@/components/Xlsx";
import EditorBar from '@/components/Richtext'
import Paging from '@/components/Paging';
export default {
  name: "location",
  components: {
    Xlsx,
    EditorBar,
    Paging
  },
  data() {
    return {
        beginData:{},
        tableData: [],
        pageNum: 1,
        pageSize: 10,
        userdata: {},
        total: 0,
        fullscreenLoading: true,
        formname: JSON.stringify({name:'地址管理',hint:'location:export'}),
        mydata:[]
    };
  },
  created() {
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  mounted() {
  },
  methods: {
    resets(){
        this.$router.push('/refresh')
    },
    reset() {
      this.begin();
    },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin();
    },
    begin() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        id:this.beginData.id,
        mobile:this.beginData.mobile,
        name:this.beginData.nickname,
        areasid: userdata.areasId
      });
      this.$axios.post(`/api-s/getUserAddressList`, data, {headers: { accessToken: userdata.token }})
        .then(res => {
            this.fullscreenLoading = false;
            if(res.data.success){
                this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
                    this.$set(this, "tableData", res.data.pageInfo.list);
                });
                this.$set(this, "total", res.data.pageInfo.total);
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
            }else{
              this.$message(res.data.msg)
            }
        });
    },
    query() {
      this.fullscreenLoading = true;
      this.begin();
    }
  }
};
</script>
<style>
.w-e-toolbar{
  flex-wrap: wrap;
}
#location .el-input__inner {
  margin: 10px 0;
}
#location .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#location .el-menu-item.is-active{
  background: none
}
#location .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#location .el-tag{
  margin-right: 12px;
}
#location .el-select {
  /* margin: 0 8px; */
}
#location .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
.input-new-tag{
  width: 20%
}
#location .el-upload-list--picture .el-upload-list__item {
    width: 44%;
    float: left;
    margin-right: 2%;
}
#location .el-form-item__content {
    width: 100%;
}
#location .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#location .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#location .el-dialog__body {
  height: 100%;
}
#location .el-form-item{
    display: flex;
    align-items: center;
    margin-bottom:0
}
#location .el-form-item__label{
    width: 122px
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
      color: red;
    margin-left: 8px;
}
.summary>span:first-child{
    margin-right: 20px
}
.summary>span:first-child i{
    color:red
}
.summary>span:last-child i{
    color:green
}
.staimg{
    position: absolute;
    left: -26px;
    top: 10px;
    width: 18px;
}
.dtstat span{
    margin: 0 34px;
}
</style>
